module.exports = __webpack_public_path__ + "img/7.e2c6f629.png";